/**
 * 列表页 CTR 埋点（rovdesy · hyt-pm docs/shopify-tracking-spec.md §3.3/§3.5 v1.2）
 *
 * 做什么：collection 页每张商品卡（product-item）发一条 GA4 view_item_list（曝光）；
 * 点击卡内详情页链接时发一条 select_item。参数：item_list_name / item_list_id /
 * item_index / item_page / ctr_source=theme + ecommerce.items（item_id=variant SKU），
 * sitehub 按天抓取后动态计算 CTR。
 *
 * ⚠️ 发送通道（2026-10-27 方案一，用户拍板）：主文档 gtag 直发 GA4（send_to
 * G-JYC3KWDZJP）。不走 dataLayer→GTM——rovdesy 的 GTM 容器跑在 Shopify web-pixel
 * 沙盒里，主文档 dataLayer 事件沙盒看不见（Tag Assistant「GTM-PSW4NP4B not found」
 * 实证）；gtag.js 由 Simprosys googtag 全站加载，此处直接复用。GTM 里的对应触发器/
 * 标签保留但本店暂不依赖（未来注入主文档后再切回）。
 *
 * 口径：
 * - 曝光 = 渲染即曝光：卡片渲染完成即算（含翻页 / 无限加载追加页），不做滚动可见性判断。
 *   首屏 DOMContentLoaded 扫一遍；无限加载的追加卡片（Section Rendering API 注入
 *   .product-list__inner）由 MutationObserver 捕获。
 * - 坑位：data-index = 页内位序（forloop.index，1 起），data-page = 列表页码；搜索 / 推荐位 /
 *   mini cart 等复用场景不传 position（data-index 为空），天然不采集。
 * - 每张卡曝光只计一次（锚点 expando 去重）；点击每次都计（每次点击是独立行为）。
 * - data-sku 为空（变体无 SKU）的卡不采集，曝光点击同口径跳过。
 * - consent：读 Simprosys consent cookie（_gsf_sh_cc），analyticsProcessingAllowed=false
 *   时不发送；cookie 不存在或解析失败按允许处理（与 GTM consent NOT_NEEDED 一致）。
 */
(function () {
  'use strict';
  if (window.__rovListCtrLoaded) return;
  window.__rovListCtrLoaded = true;

  var BOUND = '__rovListCtrViewed';
  var MEASUREMENT_ID = 'G-JYC3KWDZJP';

  function consentAllows() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_gsf_sh_cc=([^;]*)/);
      if (!m) return true;
      var cc = JSON.parse(decodeURIComponent(m[1]));
      return !(cc && cc.analyticsProcessingAllowed === false);
    } catch (e) {
      return true;
    }
  }

  function payload(el) {
    var sku = el.getAttribute('data-sku');
    var index = parseInt(el.getAttribute('data-index'), 10);
    if (!sku || !index || index < 1) return null;
    var page = parseInt(el.getAttribute('data-page'), 10) || 1;
    return {
      item_list_name: el.getAttribute('data-list-name') || '',
      item_list_id: el.getAttribute('data-list-id') || '',
      item_index: String(index),
      item_page: String(page),
      ctr_source: 'theme',
      // gtag 直发：items 必须在顶层（ecommerce 包装是 GTM dataLayer 约定，gtag 不识别）
      items: [{
        item_id: sku,
        item_name: el.getAttribute('data-item-name') || '',
        item_list_name: el.getAttribute('data-list-name') || '',
        item_list_id: el.getAttribute('data-list-id') || '',
        index: index
      }]
    };
  }

  // gtag.js 异步加载，DOMContentLoaded 时刻可能未就绪：最多重试 5 次 × 1.5s。
  function send(eventName, el, attempt) {
    if (!consentAllows()) return;
    if (typeof window.gtag !== 'function') {
      if ((attempt || 0) < 5) {
        setTimeout(function () { send(eventName, el, (attempt || 0) + 1); }, 1500);
      }
      return;
    }
    var data = payload(el);
    if (!data) return;
    window.gtag('event', eventName, Object.assign({ send_to: MEASUREMENT_ID, transport_type: 'beacon' }, data));
  }

  function scan(root) {
    var cards = (root || document).querySelectorAll('product-item');
    Array.prototype.forEach.call(cards, function (card) {
      var anchor = card.querySelector('a[data-sku][data-index]');
      if (!anchor || anchor[BOUND]) return;
      anchor[BOUND] = true;
      send('view_item_list', anchor);
    });
  }

  // 点击：委托到 document（捕获段），动态追加页的卡无需单独绑定。
  // 直发模式下 GA4 事件名必须是 select_item（GTM 映射层已不在链路里）。
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    var anchor = target && target.closest ? target.closest('a[data-sku][data-index]') : null;
    if (anchor) send('select_item', anchor);
  }, true);

  function boot() {
    scan(document);
    var grid = document.querySelector('.product-list__inner');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { scan(grid); })
        .observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
